import { useContext, useEffect, useState } from "react"
import { CustomizerContext } from "../context/CustomizerContext"

const useLanguages = () => {
  const { document } = useContext(CustomizerContext)
  const yLanguages = document && document.getArray('languages')
  const [languages, setLanguages] = useState([])

  useEffect(() => {
    if (document) {
      const langsJson = yLanguages && yLanguages.toJSON()
      setLanguages([yLanguages, langsJson])
    }
  }, [document, yLanguages])

  useEffect(() => {
    if (yLanguages) {
      const observer = (e) => {
        const langs = e?.currentTarget
        const langsJson = langs.toJSON()
        setLanguages([langs, langsJson])
      }

      yLanguages.observe(observer)
      return () => yLanguages.unobserve(observer)
    }
  }, [document, yLanguages])

  return languages
}

export default useLanguages
